import { css } from 'emotion';

export const triggerWrapper = css`
  display: inline-block;
`;

/*
  This z-index is to show full popper when popper is under some element with position:absolute.
*/
export const popper = css`
  z-index: 9999;
`;
